module.exports = __webpack_public_path__ + "static/media/white-logo.f5fb226a.png";